<template>
	<div class="incenters">
		<div style="width: 99%;">
			<Commontable @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination :pageSize="pageSize" @handleCurrentChange="handleCurrentChange"
					@handleSizeChange="handleSizeChange" :total="total"></Pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import Commontable from '../../../components/common-table.vue'
	import Pagination from '../../../components/pagination.vue'

	export default {
		components: {
			Commontable,
			Pagination
		},
		props: {
			tableData: [],
			total: 0,
			pageSize: 0,
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				ptype: '',
				fromdataadd: [],
				fromdataedit: [],

				cCompanyId: '',
				authorityName: '',
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50
					},
					{
						prop: 'RoleName',
						label: '角色/用户名称',
						columnwidth: 270
					},
					{
						prop: 'OpType',
						label: '类型',
						columnwidth: 268
					},
				],
			}
		},
		created() {},
		mounted() {

		},
		methods: {
			onRowClick(val) {
				this.$emit('onRowClick', val)
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)

			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
		},
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 20px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// flex-wrap: wrap;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}
</style>